import script from "./pageHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./pageHeader.vue?vue&type=script&setup=true&lang=ts"

import "./pageHeader.vue?vue&type=style&index=0&id=1059f524&lang=scss&scoped=true"
import "./pageHeader.vue?vue&type=style&index=1&id=1059f524&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1059f524"]])

export default __exports__